import { Center } from '@chakra-ui/react';
import PlayerVideoButton from './PlayerVideoButton';

/**
 * Marks a still as the cover of a video. Decorative: the card itself is the
 * interactive target, and the click opens the preview.
 */
export function MentionVideoBadge() {
  return (
    <Center
      position="absolute"
      inset={0}
      pointerEvents="none"
      aria-hidden
      data-testid="mention-video-badge"
    >
      <PlayerVideoButton size="md" />
    </Center>
  );
}

export default MentionVideoBadge;
